module.exports = __webpack_public_path__ + "static/media/ins-2.cdc9d290.webp";